import axios from 'axios'
import cryptoRandomString from 'crypto-random-string'

export const buildFormData = (file, data, storageKey = null) => {
  if (!storageKey) {
    return
  }

  const params = {
    'key': storageKey,
    'policy': data['policy'],
    'Content-Type': file.type,
    'x-amz-credential': data['xAmzCredential'],
    'x-amz-algorithm': data['xAmzAlgorithm'],
    'x-amz-date': data['xAmzDate'],
    'x-amz-signature': data['xAmzSignature']
  }

  if (data.metadata) {
    Object.keys(data.metadata).forEach(k => params[k.toLowerCase()] = data.metadata[k])
  } else if (data['xAmzMetaUuid']) {
    params['x-amz-meta-uuid'] = data['xAmzMetaUuid']
  }

  params.file = file
  params.acl = data['acl']

  const formData = new FormData()
  for (let key in params) {
    formData.append(key, params[key])
  }

  return { params, formData }
}

export const doUpload = async (data, formData, options, params) => {
  const s3response = await axios.post(data.s3Url, formData, options)
  if (s3response) {
    params.url = `${data.s3Url}/${params.key}`
    return { params, s3response, signedUrlData: data }
  } else {
    throw new Error('Could not upload.')
  }
}

export const buildStorageKey = (subFolder, file, filename = null) => {
  const cb = cryptoRandomString({ length: 8 })
  let fn = file.name.replace(/ /g, '_').toLowerCase()
  const filenameParts = fn.split('.')
  if (filename) {
    fn = `${filename}-${cb}.${filenameParts[1]}`.toLowerCase()
  } else {
    fn = `${filenameParts[0]}-${cb}.${filenameParts[1]}`.toLowerCase()
  }

  if (subFolder) {
    return `${subFolder}/${fn}`
  }
  return fn
}